require('./bootstrap');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('jquery-ui/ui/widgets/datepicker.js');
require('jquery-ui/ui/widgets/dialog.js');
require('jquery-ui/ui/widgets/autocomplete.js');

require('./timepicker');

// require('bootstrap/dist/js/bootstrap.min');
window.moment = require('moment/moment');

/**
 \====================================================================
 \ NOTY
 \====================================================================
 */
window.Noty = require('noty');
Noty.overrideDefaults({
    layout: 'topRight',
    theme : 'nest',
});

import Cleave from 'cleave.js';
/**
 \====================================================================
 \ SWEETALERT
 \====================================================================
 */
window.Swal = require('sweetalert2');

/**
 * Fix when sweetalert used on top of bootstrap modal.
 * Call first one before open.
 * Call Second one after close.
 */
window.fixBootstrapModal = function () {
    let modalNode = document.querySelector('.modal[tabindex="-1"]');
    if (!modalNode) return;

    modalNode.removeAttribute('tabindex');
    modalNode.classList.add('js-swal-fixed');
};

window.restoreBootstrapModal = function () {
    var modalNode = document.querySelector('.modal.js-swal-fixed');
    if (!modalNode) return;

    modalNode.setAttribute('tabindex', '-1');
    modalNode.classList.remove('js-swal-fixed');
}
Swal = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-sm btn-success px-3 mr-2',
        cancelButton: 'btn btn-sm btn-danger px-3',
        title: 'justify-content-start w-100',
        actions: 'justify-content-end'
    },
    showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
    },
    hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
    },
    buttonsStyling: false,
    willOpen: fixBootstrapModal,
    didDestroy: restoreBootstrapModal
});

/**
 \====================================================================
 \ FLATPICKR (datepicker)
 \====================================================================
 */
window.flatpickr = require('flatpickr');

/**
 \====================================================================
 \ FullCalendar
 \====================================================================
 */
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';

window.FullCalendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.bootstrapPlugin = bootstrapPlugin;

window.WorkPlan = {};

require('select2/dist/js/select2.full.min');
require('./bootstrap-switch.min');
require('./bootstrap-tokenfield.min');
require('./bootstrap-editable.min');
require('./classie');
require('jquery-mask-plugin');
require('./jquery.stickytableheaders.min');
require('./formatter/phoneNumberFormatter');
require('./selectFx');
require('bootstrap-select')
require('./notifications/header-messages');

require('./main');

require('./sidebar');

/**
 \====================================================================
 \ File inputs
 \====================================================================
 */
;(function( $, window, document, undefined ) {
    $('.inputfile').each( function() {
        let $input	 = $( this ),
            $label	 = $input.next('label'),
            labelVal = $label.html();

        $input.on('change', function(e) {
            let fileName = '';

            if (this.files && this.files.length > 1)
                fileName = (this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length);
            else if ( e.target.value )
                fileName = e.target.value.split( '\\' ).pop();

            if (fileName)
                $label.find('span:first-child').html(fileName);
            else
                $label.html(labelVal);
        });

        // Firefox bug fix
        $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });

    $('[data-toggle=popover]').popover();
})(jQuery, window, document);


$.fn.serializeJSON = function() {
    var data = {};
    $.map(this.serializeArray(), function(n) {
        const keys = n.name.match(/[a-zA-Z0-9_]+|(?=\[\])/g);
        if (keys.length > 1) {
            let tmp = data;
            let pop = keys.pop();
            let j;
            for (let i = 0; i < keys.length, j = keys[i]; i++) {
                tmp[j] = (!tmp[j] ? (pop === '') ? [] : {} : tmp[j]), tmp = tmp[j];
            }
            if (pop === '') tmp = (!Array.isArray(tmp) ? [] : tmp), tmp.push(n.value);
            else tmp[pop] = n.value;
        } else data[keys.pop()] = n.value;
    });

    return data;
}

